import type { Calendar } from 'modules/attendance/store/collections/calendar'

export interface PeriodProps {
  year: number
  month: number
}

export enum GroupByTypes {
  team = 'team',
  employee = 'employee',
}

export type StoreProps = PeriodProps & {
  employeeId: number
  currentEmployeeId: number | null | undefined
  attendanceEmployeesSettingId?: number | null
  calendar?: Calendar
  layout?: Layout
  hasNewProjectsSection?: boolean
}

export enum Layout {
  employee = 'employee',
  admin = 'admin',
}

export enum InconsistencyState {
  pending = 'pending',
  resolved = 'resolved',
  ignored = 'ignored',
}
